import { render, staticRenderFns } from "./Allowance.vue?vue&type=template&id=f96dfb38&scoped=true"
import script from "./Allowance.vue?vue&type=script&lang=js"
export * from "./Allowance.vue?vue&type=script&lang=js"
import style0 from "./Allowance.vue?vue&type=style&index=0&id=f96dfb38&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f96dfb38",
  null
  
)

export default component.exports